"use client";

import type { ButtonProps } from "app/_components/components/Button";
import { CreditCardApplyLink } from "./CreditCardApplyLink";
import { RegistrationDownloadLink } from "./RegistrationDownloadLink";
import { RegistrationLink } from "./RegistrationLink";
import { usePathname } from "i18n/routing";

export function GetStartedLink({
  referralCode,
  label,
  ...props
}: {
  referralCode?: string;
  label: string;
} & ButtonProps) {
  const pathname = usePathname();

  const isCreditCardPage = pathname.startsWith("/credit-card");
  const isGoogleSearchPage = pathname.startsWith("/lp/exchangeapp");

  if (isCreditCardPage) {
    const isBusiness = pathname.includes("/credit-card/business");
    return (
      <CreditCardApplyLink
        isBusiness={isBusiness}
        label={label}
        referralCode={referralCode}
        {...props}
      />
    );
  }

  if (isGoogleSearchPage)
    return <RegistrationDownloadLink referralCode={referralCode} {...props} />;

  return (
    <RegistrationLink label={label} referralCode={referralCode} {...props} />
  );
}
